module.exports = __webpack_public_path__ + "static/media/icon-pie-chart.22f10292.svg";